var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',[_vm._v("diaigo accounting")])])}
var staticRenderFns = []

export { render, staticRenderFns }